import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { Col, Form, Row, Container } from "react-bootstrap";
import CustomSettlement from "../../components/CustomSettlement";
import * as axiosInstance from "../../services/axiosInstance";
import Helper from "../../utils/Helper";
import _ from "lodash";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import * as authSelectors from "../../selectors/auth";
import * as StorageManager from "../../utils/StorageManager";
import constants from "../../constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileLines,
  faFileArrowDown,
} from "@fortawesome/free-solid-svg-icons";
import * as outstandingSelectors from "../../selectors/outstanding";
import * as userSelectors from "../../selectors/user";
import { getGeneralDateOutstandingSummaryValue } from "../../selectors/general";
import * as generalSelectors from "../../selectors/general";
import Constants from "../../constants";
import OutstandingPositionTrustSection from "./components/OutstandingPositionTrustSection";
import OutstandingPositionSalesContractSection from "./components/OutstandingPositionSalesContractSection";
import OutstandingPositionPurchaseContractSection from "./components/OutstandingPositionPurchaseContractSection";
import OutstandingPositionOthersSection from "./components/OutstandingPositionOthersSection";
import OutstandingPositionInterestSection from "./components/OutstandingPositionInterestSection";
import Image from "react-bootstrap/Image";
import { apiInstance } from "../../services/httpService";
import LoadingOverlay from "../../components/LoadingOverlay";
import OutstandingPositionContraGainSection from "./components/OutstandingPositionContraGainSection";
import OutstandingPositionContraLossSection from "./components/OutstandingPositionContraLossSection";

function ESettlement({ generalData }) {
  const dispatch = useDispatch();
  const [token, setToken] = useState(null);
  const isLogout = useSelector((state) => authSelectors.getAuthIsLogout(state));
  const date = new Date();
  const dateNow = date.toISOString().split("T")[0];
  const [downloadLoading,setDownloadLoading] = useState(false);
  const [currentDate, setCurrentDate] = useState(dateNow);
  const userState = useSelector((state) => state.user);
  const accountSelections = userSelectors.getUserAccountSelections(userState);
  const clientName = userSelectors.getUserName(userState);
  const selectedAccount = _.find(accountSelections, "is_selected");
  const userText =
    userSelectors.getUserAccountSelectionsUserText(selectedAccount);
  const selectedCurrencyText =
    userSelectors.getUserAccountCurrencySelected(userState);
  useEffect(() => {
    const outStandingSummaryDate =
      generalSelectors.getGeneralDateOutstandingSummaryValue(generalData);
    if (!_.isEmpty(outStandingSummaryDate)) {
      setCurrentDate(outStandingSummaryDate);
    }
  }, [generalData]);

  useEffect(() => {
    setTokenFunction();
  }, [isLogout]);

  async function setTokenFunction() {
    setToken(await StorageManager.retrieveToken(constants.AUTH_TOKEN));
  }

  const onClickDownloadPDF = async () => {
    if(downloadLoading){
      return
    }
    const axios = apiInstance(
      {
        responseType: "blob",
        contentType: "application/pdf",
      },
      { responseType: "blob" },
    );
    try {
      setDownloadLoading(true);
      const response = await axios.get(
        `clientarea/statement/outstanding-summary?data_date=${currentDate}&pdf=1`,
      );
      if (response.status === 200) {
        const data = new Blob([response.data], { type: "application/pdf" });
        let downloadUrl = window.URL.createObjectURL(data);
        let downloadLink = document.createElement("a");
        downloadLink.href = downloadUrl;
        downloadLink.setAttribute(
          "download",
          `outstanding-positions-${currentDate}.pdf`,
        );
        downloadLink.click();
      }
    } catch (error) {
      axiosInstance.httpErrorHelpers(error);
    }
    finally {
      setDownloadLoading(false);

    }
  };

  const onChangeDate = (e) => {
    setCurrentDate(e.target.value);
  };

  //API CALL
  const outstandingStatement = useQuery({
    queryKey: ["outstanding-statement", { currentDate }],
    queryFn: async () => {
      try {
        return await axiosInstance.get(
          `clientarea/statement/outstanding-summary?data_date=${currentDate}`,
        );
      } catch (e) {
        Helper.handleHttpError(e, dispatch);
      }
    },
    retryDelay: 15000,
    enabled: !_.isEmpty(token),
  });
  const outstandingDatalist = _.get(outstandingStatement, ["data", "data"], []);
  const trustMoneyDataList =
    outstandingSelectors.getOutstandingTrustMoney(outstandingDatalist);
  const salesContractDataList =
    outstandingSelectors.getOutstandingSalesContract(outstandingDatalist);
  const purchasedContractDataList =
    outstandingSelectors.getOutstandingPurchasedContract(outstandingDatalist);
  const otherContractDataList =
    outstandingSelectors.getOutstandingOtherContract(outstandingDatalist);
  const interestContractDataList =
    outstandingSelectors.getOutstandingInterestContract(outstandingDatalist);
  const contractLossDataList =
    outstandingSelectors.getOutstandingContractLoss(outstandingDatalist);
  const contractGainDataList =
    outstandingSelectors.getOutstandingContractGain(outstandingDatalist);
  const loading = _.get(outstandingStatement, ["isLoading"], false);
  return (
    <Container fluid>
      {/*// ======= Head Section ======== */}
      <div className="mb-3">
        <Row>
          <Col md={12} lg={6}>
            <div
              className={clsx(
                "custom-table-title-container justify-content-lg-start justify-content-center",
              )}
            >
              <p> {clientName} </p>
              <p> ( {userText} ) </p>
            </div>
          </Col>
          <Col md={12} lg={6}>
            <div className="d-flex align-items-center float-end justify-content-center">
              {/*<Form.Control*/}
              {/*  type="date"*/}
              {/*  max={dateNow}*/}
              {/*  className="custom-settlement-datepicker-white"*/}
              {/*  value={currentDate}*/}
              {/*  onChange={onChangeDate}*/}
              {/*/>*/}
              <a
                className="download-btn ms-2 "
                onClick={() => onClickDownloadPDF()}
              >
                <Image
                  src="/img/icon/download.png"
                  style={{ width: "18px", objectFit: "contain" }}
                />
                <LoadingOverlay isSemiLoading={true} loading={downloadLoading}></LoadingOverlay>
              </a>
            </div>
          </Col>
        </Row>
      </div>

      <div
        className={"primary-border-table-border"}
        style={{ backgroundColor: "white" }}
      >
        <div
          className={clsx(
            "d-flex custom-card-label-container align-items-center",
          )}
        >
          <FontAwesomeIcon
            icon={faFileLines}
            className="fa-2x"
            style={{ marginRight: "10px", color: "white" }}
          />
          <h2>Outstanding Positions</h2>
        </div>

        {/*// ======= Trust Money Section ======== */}
        <OutstandingPositionTrustSection
          title="1. Trust"
          data={trustMoneyDataList}
          selectedCurrencyText={selectedCurrencyText}
          loading={loading}
        ></OutstandingPositionTrustSection>
        {/*// ======= Sales Contract Section ======== */}
        <OutstandingPositionSalesContractSection
          title="2. Sales"
          data={salesContractDataList}
          selectedCurrencyText={selectedCurrencyText}
          loading={loading}
        ></OutstandingPositionSalesContractSection>
        {/*// ======= Purchase Contract Section ======== */}
        <OutstandingPositionPurchaseContractSection
          title="3. Purchase"
          data={purchasedContractDataList}
          selectedCurrencyText={selectedCurrencyText}
          loading={loading}
        ></OutstandingPositionPurchaseContractSection>
        {/*// ======= Contra Gain Contract Section ======== */}
        <OutstandingPositionContraGainSection
          title="4. Contra Gain"
          data={contractGainDataList}
          selectedCurrencyText={selectedCurrencyText}
          loading={loading}
        ></OutstandingPositionContraGainSection>
        {/*// ======= Contra Loss Contract Section ======== */}
        <OutstandingPositionContraLossSection
          title="5. Contra Loss"
          data={contractLossDataList}
          selectedCurrencyText={selectedCurrencyText}
          loading={loading}
        ></OutstandingPositionContraLossSection>
        {/*// ======= Interest Contract Section ======== */}
        <OutstandingPositionInterestSection
          title="6. Interest"
          data={interestContractDataList}
          selectedCurrencyText={selectedCurrencyText}
          loading={loading}
        ></OutstandingPositionInterestSection>
        {/*// ======= Other Contract Section ======== */}
        <OutstandingPositionOthersSection
          title="7. Others"
          data={otherContractDataList}
          selectedCurrencyText={selectedCurrencyText}
          loading={loading}
        ></OutstandingPositionOthersSection>

        {/*// ======= Nett Total Section ======== */}
        {/*<div className="outstanding-black-bg-content">*/}
        {/*    <p>NET BALANCE </p>*/}
        {/*    <p>-9,885.17 MYR</p>*/}
        {/*</div>*/}
        {/*<div className="outstanding-black-bg-content">*/}
        {/*    <p>PORTFOLIO VALUE </p>*/}
        {/*    <p>0.00 MYR</p>*/}
        {/*</div>*/}
      </div>
    </Container>
  );
}

export default ESettlement;
